export const ModalOptionsView = Backbone.Marionette.Layout.extend({
    template: '#tpl_modal_options',
    class_name: '',
    top: null, // we will position the modal based on these
    right: null,
    buttons: null, // list of button messages
    text: '', // explanation text (opt)

    events: {
        'click .flyout_touchblock': 'non_button_close',
        'touchdown .flyout_touchblock': 'non_button_close'
    },

    templateHelpers: function () {
        return {
            buttons: this.buttons,
            text: this.text,
            class_name: this.class_name
        };
    },

    initialize: function (options) {
        var this_ = this;
        options = options || {};
        $.extend(this, options);

        if (this.top === null || this.right === null) {
            throw new Error('Programmer Error: ModalOptionsView requires top and right position.');
        }
        if (this.buttons.length === 0) {
            throw new Error('Programmer Error: ModalOptionsView must receive at least one button.');
        }

        _.each(this.buttons, function (actions, idx) {
            var click_class = `click .btn_${idx}`;
            this_.events[click_class] = function () {
                this_.callback(idx + 1);
                this_.close();
            };
        });
    },

    onShow: function () {
        this.$el.find('.flyout').css({
            right: this.right,
            top: this.top
        });

        $('.page_scrollable').on('scroll', this.non_button_close.bind(this));
        window.addEventListener('resize', this.non_button_close.bind(this));
    },

    onBeforeClose: function () {
        $('.page_scrollable').off('scroll', this.non_button_close.bind(this));
        window.removeEventListener('resize', this.non_button_close.bind(this));
    },

    /**
     * In an attempt to emulate the current behavior of actionSheet, any clicking out of this modal
     * to close it will callback with 3 (cancel), even if cancel - or any other generic third option - was not provided
     * to this modal. We also call it with false as a second argument to allow callers to denote
     * that this second argument was a click out, not a button press
     */
    non_button_close: function () {
        this.callback(3, false);
        this.close();
    }
});
